<template>
  <div class="fRow jStart aStart fullWidth questionBankHolder">
    <!-- add question form -->
    <div class="addQuestion fRow jBetween aStart wrap growFull">
      <upload-excel v-if="false"/>
      <div class="fRow jBetween aStart fullWidth wrap"
        v-if="(!qEditMode) || (qEditMode && letEdit)">
        <h4 class="fullWidth">فرم اضافه کردن سؤال جدید به بانک سؤالات</h4>
        <div class="filterBox w50 fRow jStart aCenter">
          <div class="ih fullWidth fCol jStart aStart">
            <span>انتخاب سطح سؤال</span>
            <cool-select
              class="fullWidth"
              v-model="qLevel"
              disable-search
              :items="questionLevels"/>
          </div>
        </div>
        <div class="filterBox w50 fRow jStart aCenter">
          <div class="ih fullWidth fCol jStart aStart">
            <span>انتخاب طبقه‌بندی</span>
            <cool-select
              class="fullWidth"
              @select="selected($event, 'addQuestionClassification')"
              v-model="questionClassificationSelected"
              :items="classifications"
              :item-value="classifications.id"
              :item-text="classifications.title">
              <!-- slot for each item in the menu -->
              <template slot="item" slot-scope="{ item: classifications }">
                <div style="display: flex; align-items: center;">
                  <div>
                    {{ classifications.title }}
                    <b>{{ classifications.value }}</b>
                  </div>
                </div>
              </template>
              <!-- slot for the selected item (in the text field) -->
              <template slot="selection" slot-scope="{ item: classifications }">
                <div>
                  {{ classifications.title }}
                  <b>{{ classifications.value }}</b>
                </div>
              </template>
            </cool-select>
          </div>
        </div>
      </div>
      <!-- متن سؤال -->
      <div class="fullWidth fCol jStart align-self-start Q"
        style="margin-bottom: 0; margin-top: 16px">
        <span class="fRow jStart aCenter sectionHead">
          <i class="material-icons-round">help</i>متن سؤال
          <div class="fRow jEnd aCenter growFull">
            <a href="https://katex.org/docs/support_table.html"
              class="howToFormula"
              target="_blank">آموزش نوشتن فرمول</a>
          </div>
        </span>
        <div class="fRow jStart aCenter fullWidth inputWraper">
          <textarea
            v-if="false"
            style="height: 88px"
            class="transition-fast" placeholder="متن سؤال"
            type="text" v-model="question"></textarea>
        </div>
        <quill-editor ref="myTextEditor"
          class="fullWidth qlClass inputWraper"
          v-model="question"
          :options="quillOptions">
        </quill-editor>
        <get-photo-exam
          w='100%'
          v-on:photoupload="getUploaded($event, 'question')"
          photoFor='question'
          :initImg='questionMedia'
          uploadMsg='الزامی نیست'
          uploadLabel='تصویر یا فایل ورد مربوط به سؤال'/>
      </div>
      <!-- گزینه اول -->
      <div class="w50 fCol jStart aStart inputHolder QO"
        v-if="isTestQuestion"
        style="margin-bottom: 0;">
        <span class="fRow jStart aCenter"><i class="material-icons-round">check_box</i>
          گزینه‌ی الف</span>
        <div class="fRow jStart aCenter fullWidth inputWraper">
          <i class="isTrueCheckBox material-icons-round transition-fast"
            @click="testTrueAnswer = 'A'"
            v-bind:class="{selected: testTrueAnswer === 'A'}">
            <div class="tick transition-fast"></div>
          </i>
          <!-- <textarea class="transition-fast qo" placeholder="گزینه‌ی الف"
            v-model="testA"></textarea> -->
          <quill-editor
            class="fullWidth qlClass"
            v-model="testA"
            :options="qItemQuillOptions"></quill-editor>
        </div>
        <get-photo-exam
          w='100%'
          v-on:photoupload="getUploaded($event, 'A')"
          photoFor='testA'
          :initImg='testAMedia'
          uploadMsg='تصویر گزینه‌ی الف'
          uploadLabel=''/>
      </div>
      <!-- گزینه دوم -->
      <div class="w50 fCol jStart aStart inputHolder QO"
        v-if="isTestQuestion"
        style="margin-bottom: 0;">
        <span class="fRow jStart aCenter"><i class="material-icons-round">help</i>
          گزینه‌ی ب</span>
        <div class="fRow jStart aCenter fullWidth inputWraper">
          <i class="isTrueCheckBox material-icons-round transition-fast"
            @click="testTrueAnswer = 'B'"
            v-bind:class="{selected: testTrueAnswer === 'B'}">
            <div class="tick transition-fast"></div>
          </i>
          <!-- <textarea class="transition-fast qo" placeholder="گزینه‌ی ب"
            v-model="testB"></textarea> -->
          <quill-editor
            class="fullWidth qlClass"
            v-model="testB"
            :options="qItemQuillOptions"></quill-editor>
        </div>
        <get-photo-exam
          w='100%'
          v-on:photoupload="getUploaded($event, 'B')"
          photoFor='testB'
          :initImg='testBMedia'
          uploadMsg='تصویر گزینه‌ی ب'
          uploadLabel=''/>
      </div>
      <!-- گزینه سوم -->
      <div class="w50 fCol jStart aStart inputHolder QO"
        v-if="isTestQuestion"
        style="margin-bottom: 0;">
        <span class="fRow jStart aCenter"><i class="material-icons-round">help</i>
          گزینه‌ی ج</span>
        <div class="fRow jStart aCenter fullWidth inputWraper">
          <i class="isTrueCheckBox material-icons-round transition-fast"
            @click="testTrueAnswer = 'C'"
            v-bind:class="{selected: testTrueAnswer === 'C'}">
            <div class="tick transition-fast"></div>
          </i>
          <!-- <textarea class="transition-fast qo" placeholder="گزینه‌ی ج"
            v-model="testC"></textarea> -->
          <quill-editor
            class="fullWidth qlClass"
            v-model="testC"
            :options="qItemQuillOptions"></quill-editor>
        </div>
        <get-photo-exam
          w='100%'
          v-on:photoupload="getUploaded($event, 'C')"
          photoFor='testC'
          :initImg='testCMedia'
          uploadMsg='تصویر گزینه‌ی ج'
          uploadLabel=''/>
      </div>
      <!-- گزینه چهارم -->
      <div class="w50 fCol jStart aStart inputHolder QO"
        v-if="isTestQuestion"
        style="margin-bottom: 0;">
        <span class="fRow jStart aCenter"><i class="material-icons-round">help</i>
          گزینه‌ی د</span>
        <div class="fRow jStart aCenter fullWidth inputWraper">
          <i class="isTrueCheckBox material-icons-round transition-fast"
            @click="testTrueAnswer = 'D'"
            v-bind:class="{selected: testTrueAnswer === 'D'}">
            <div class="tick transition-fast"></div>
          </i>
          <!-- <textarea class="transition-fast qo" placeholder="گزینه‌ی د"
            v-model="testD"></textarea> -->
          <quill-editor ref="myTextEditor"
            class="fullWidth qlClass"
            v-model="testD"
            :options="qItemQuillOptions"></quill-editor>
        </div>
        <get-photo-exam
          w='100%'
          v-on:photoupload="getUploaded($event, 'D')"
          photoFor='testD'
          :initImg='testDMedia'
          uploadMsg='تصویر گزینه‌ی د'
          uploadLabel=''/>
      </div>
      <div class="fRow jStart aCenter fullWidth"
        style="margin: 16px 0">
        <div class="b fRow jStart aCenter big"
          @click="newQuestion"
          v-if="!qEditMode"
          v-bind:class="{active: isAddQuestionReady}">
          <i class="material-icons-round">add</i>
          <label>اضافه کردن سؤال</label>
        </div>
        <div class="b fRow jStart aCenter big"
          @click="editQuestions"
          v-if="qEditMode"
          v-bind:class="{active: isEditQuestionReady}">
          <i class="material-icons-round">edit</i>
          <label>ویرایش سؤال</label>
        </div>
        <div class="b fRow jStart aCenter"
          v-if="qEditMode"
          @click="clearQuestion">
          <i class="material-icons-round">close</i>
          <label>بازگشت و ایجاد سؤال جدید</label>
        </div>
        <div class="b fRow jStart aCenter"
          v-if="!qEditMode"
          @click="clearQuestion">
          <i class="material-icons-round">delete</i>
          <label>پاک کردن فرم</label>
        </div>
      </div>
    </div>
    <!-- bank preview -->
    <question-bank from='exam'/>
  </div>
</template>

<script>
import axios from 'axios';
import QuestionBank from '@/components/QuestionBankGame.vue';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { quillEditor } from 'vue-quill-editor';
import katex from 'katex';
import 'katex/dist/katex.min.css';
import { CoolSelect } from 'vue-cool-select';
import { EventBus } from '@/plugins/event-bus';
import GetPhotoExam from '@/components/GetPhotoExam.vue';

export default {
  data() {
    return {
      baseURL: this.$store.state.baseUrl,
      V: this.$store.state.apiVersion,
      // modes ↓
      loading: false,
      noContent: false,
      notFound: false,
      error: false,
      notYet: false,
      loaded: true,
      modeMsg: '',
      // modes ↑
      qEditMode: false,
      questionLevels: [
        'آسان',
        'متوسط',
        'سخت',
      ],
      qLevel: '',
      qLevelErr: true,
      questionTypes: [
        'تستی',
        'تشریحی',
      ],
      questionTypeSelected: 'تستی',
      qTypeSelectedErr: false,
      classifications: [
        'لطفا طبقه بندی را انتخاب کنید',
      ],
      questionClassificationSelected: '',
      qClassificationId: '',
      qClassificationIdErr: true,
      isTestQuestion: true,
      question: '',
      questionErr: true,
      questionMedia: '',
      questionMediaInit: '',
      testTrueAnswer: '',
      tTrueAnsErr: true,
      testA: '',
      testAErr: true,
      testAMedia: '',
      testAMediaInit: '',
      testB: '',
      testBErr: true,
      testBMedia: '',
      testBMediaInit: '',
      testC: '',
      testCErr: true,
      testCMedia: '',
      testCMediaInit: '',
      testD: '',
      testDErr: true,
      testDMedia: '',
      testDMediaInit: '',
      // editor data
      name: 'app',
      content: '<p></p>',
      quillOptions: {
        placeholder: 'متن سؤال را وارد کنید',
        modules: {
          toolbar: [
            [{ size: [] }],
            // [{ header: [1, 2, 3, 4, 5, 6, false] }],
            ['bold', 'underline', 'strike'],
            [{ color: [] }, { background: [] }],
            [{ script: 'super' }, { script: 'sub' }],
            // ['blockquote', 'code-block'],
            // [{ header: '1' }, { header: '2' }, 'blockquote', 'code-block'],
            // [{ list: 'ordered' }, { list: 'bullet' }, { indent: '-1' }, { indent: '+1' }],
            // [{ direction: 'ltr' }, { align: [] }, 'formula'],
            ['image', 'formula'],
            ['clean'],
          ],
        },
      },
      qItemQuillOptions: {
        placeholder: 'متن گزینه را وارد کنید',
        modules: {
          toolbar: [
            ['formula', 'clean'],
            ['bold', 'underline'],
            [{ color: [] }, { background: [] }],
          ],
        },
      },
    };
  },
  components: {
    QuestionBank,
    quillEditor,
    CoolSelect,
    GetPhotoExam,
  },
  computed: {
    isAddQuestionReady() {
      // اینجا باید ببینیم کدوم یکی از دوحالت زیر هستند
      // field
      const justClassification = this.qSelectedFieldErr
        && this.qSelectedGradeIdErr
        && this.qLessonIdErr;
      const optionalClassification = !this.qSelectedFieldErr;
      this.setClassification(justClassification, optionalClassification);
      // console.warn(justClassification);
      // console.warn(optionalClassification);
      // console.warn('---------');
      const isTest = this.questionTypeSelected === 'تستی';
      let isFormValid = false;
      // //////////////////////
      if (isTest) {
        if (justClassification) {
          isFormValid = !this.questionErr
            && !this.tTrueAnsErr
            && (!this.testAErr || this.testAMedia !== '')
            && (!this.testBErr || this.testBMedia !== '')
            && (!this.testCErr || this.testCMedia !== '')
            && (!this.testDErr || this.testDMedia !== '')
            && !this.qTypeSelectedErr
            && !this.qLevelErr
            && !this.qClassificationIdErr;
        } else if (optionalClassification) {
          isFormValid = !this.questionErr
            && !this.tTrueAnsErr
            && (!this.testAErr || this.testAMedia !== '')
            && (!this.testBErr || this.testBMedia !== '')
            && (!this.testCErr || this.testCMedia !== '')
            && (!this.testDErr || this.testDMedia !== '')
            && !this.qTypeSelectedErr
            && !this.qLevelErr
            && !this.qSelectedFieldErr
            && !this.qSelectedGradeIdErr
            && !this.qLessonIdErr;
        }
      } else {
        // eslint-disable-next-line
        if (justClassification) {
          isFormValid = !this.questionErr
            && !this.qTypeSelectedErr
            && !this.qLevelErr
            && !this.qClassificationIdErr;
        } else if (optionalClassification) {
          isFormValid = !this.questionErr
            && !this.qTypeSelectedErr
            && !this.qLevelErr
            && !this.qSelectedFieldErr
            && !this.qSelectedGradeIdErr
            && !this.qLessonIdErr;
        }
      }
      return isFormValid;
    },
    isEditQuestionReady() {
      if (this.questionTypeSelected === 'تستی') {
        // eslint-disable-next-line
        return !this.questionErr && !this.tTrueAnsErr && (!this.testAErr || this.testAMedia !== '') && (!this.testBErr || this.testBMedia !== '') && (!this.testCErr || this.testCMedia !== '') && (!this.testDErr || this.testDMedia !== '');
      }
      // eslint-disable-next-line
      return !this.questionErr;
    },
  },
  methods: {
    setMode(m, msg) {
      this.noContent = false;
      this.loading = false;
      this.notYet = false;
      this.error = false;
      this.loaded = false;
      this.modeMsg = '';
      switch (m) {
        case 'loading': {
          this.loading = true;
          break;
        }
        case 'loaded': {
          this.loaded = true;
          break;
        }
        case 'error': {
          this.modeMsg = msg;
          this.error = true;
          break;
        }
        case 'notYet': {
          this.notYet = true;
          break;
        }
        case 'noContent': {
          this.noContent = true;
          break;
        }
        default:
          break;
      }
    },
    initEdit(question) {
      this.editQuestionId = question.id;
      this.editQuestionType = question.isTest;
      this.qEditMode = true;
      this.letEdit = false;
      this.question = question.title;
      this.questionMedia = question.img;
      this.getUploaded(this.questionMedia, 'question');
      this.testA = question.options[0].text;
      this.testAMedia = question.options[0].media;
      this.getUploaded(this.testAMedia, 'A');
      this.testB = question.options[1].text;
      this.testBMedia = question.options[1].media;
      this.getUploaded(this.testBMedia, 'B');
      this.testC = question.options[2].text;
      this.testCMedia = question.options[2].media;
      this.getUploaded(this.testCMedia, 'C');
      this.testD = question.options[3].text;
      this.testDMedia = question.options[3].media;
      this.getUploaded(this.testDMedia, 'D');
      // options
      for (let i = 0; i <= 3; i += 1) {
        if (question.options[i].correctAnswer) {
          switch (i) {
            case 0: {
              this.testTrueAnswer = 'A';
              break;
            }
            case 1: {
              this.testTrueAnswer = 'B';
              break;
            }
            case 2: {
              this.testTrueAnswer = 'C';
              break;
            }
            case 3: {
              this.testTrueAnswer = 'D';
              break;
            }
            default:
              break;
          }
        }
      }
    },
    setClassification(jc, oc) {
      this.justClassification = jc;
      this.optionalClassification = oc;
    },
    clearQuestion() {
      this.question = '';
      this.questionMedia = '';
      this.testTrueAnswer = '';
      this.testA = '';
      this.testAMedia = '';
      this.testB = '';
      this.testBMedia = '';
      this.testC = '';
      this.testCMedia = '';
      this.testD = '';
      this.testDMedia = '';
      this.qEditMode = false;
      this.letEdit = false;
      // this.qLevel = '';
      // this.questionSelectedField = '';
      // this.questionGradeSelected = '';
      // this.qSelectedGradeId = '';
      // this.questionLessonSelected = '';
      // this.qLessonId = '';
      EventBus.$emit('clearPhoto');
    },
    getUploaded(e, item) {
      switch (item) {
        case 'question': {
          this.questionMedia = e;
          break;
        }
        case 'A': {
          this.testAMedia = e;
          break;
        }
        case 'B': {
          this.testBMedia = e;
          break;
        }
        case 'C': {
          this.testCMedia = e;
          break;
        }
        case 'D': {
          this.testDMedia = e;
          break;
        }
        default:
          break;
      }
    },
    getClassification() {
      this.setMode('loading');
      this.classifications = [{
        title: 'لطفا صبر کنید',
        id: '',
      }];
      const reqUrl = `${this.baseURL}/api/v${this.V}/Questions/classification`;
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        if (response.data.isSuccess) {
          this.classifications = [];
          const arr = response.data.data;
          if (arr.length === 0) {
            if (this.isSubcats) {
              this.setMode('noContent');
            }
            // ریست کردن لیست ها
            this.classifications = [{
              title: 'طبقه‌بندی ثبت نشده',
              id: '',
            }];
          } else {
            for (let i = 0; i < arr.length; i += 1) {
              this.classifications.push({
                id: arr[i].id,
                title: arr[i].name,
              });
            }
            this.setMode('loaded');
          }
        } else {
          this.responseFalse = true;
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
        this.setMode('error', this.errorHandler(error));
        // console.log(error);
      }).catch(() => {
        this.setMode('error', 'در صورت درستی اتصال اینترنت، با تیم فنی تماس بگیرید');
      });
    },
    selected(e, dropDown) {
      switch (dropDown) {
        case 'addQuestionGrade': {
          this.qSelectedGradeId = this.questionGradeSelected.id;
          if (this.qSelectedGradeId !== '') {
            this.getLesson(this.qSelectedGradeId);
          }
          break;
        }
        case 'addQuestionField': {
          this.getGrades(this.questionSelectedField.id);
          break;
        }
        case 'addQuestionLesson': {
          this.qLessonId = this.questionLessonSelected.id;
          break;
        }
        case 'addQuestionClassification': {
          this.qClassificationId = this.questionClassificationSelected.id;
          break;
        }
        default:
          break;
      }
    },
    editQuestions() {
      if (this.isEditQuestionReady) {
        const reqUrl = `${this.baseURL}/api/v${this.V}/Questions/${this.editQuestionId}`;
        let q = [];
        if (this.editQuestionType) {
          q = [
            {
              text: this.testA,
              media: this.testAMedia,
              correctAnswer: this.testTrueAnswer === 'A',
            },
            {
              text: this.testB,
              media: this.testBMedia,
              correctAnswer: this.testTrueAnswer === 'B',
            },
            {
              text: this.testC,
              media: this.testCMedia,
              correctAnswer: this.testTrueAnswer === 'C',
            },
            {
              text: this.testD,
              media: this.testDMedia,
              correctAnswer: this.testTrueAnswer === 'D',
            },
          ];
        } else {
          q = [];
        }
        axios({
          method: 'put',
          url: reqUrl,
          headers: {
            Authorization: this.$authObeject.authToken(),
          },
          data: {
            text: this.question,
            media: this.questionMedia,
            options: q,
          },
        }).then((response) => {
          if (response.data.isSuccess) {
            this.clearQuestion();
            this.letEdit = false;
            this.qEditMode = false;
            EventBus.$emit('refreshQuestionBank');
          } else {
            this.responseFalse = true;
          }
        }, (error) => {
          this.makeToast('error', this.errorHandler(error), 3000);
        });
      }
    },
    newQuestion() {
      if (this.isAddQuestionReady) {
        const reqUrl = `${this.baseURL}/api/v${this.V}/Questions`;
        let qt = 0;
        let q = [];
        let l = 0;
        switch (this.qLevel) {
          case 'سخت': {
            l = 1;
            break;
          }
          case 'متوسط': {
            l = 2;
            break;
          }
          case 'آسان': {
            l = 3;
            break;
          }
          default:
            break;
        }
        if (this.questionTypeSelected === 'تستی') {
          qt = 1;
          q = [
            {
              text: this.testA,
              media: this.testAMedia,
              correctAnswer: this.testTrueAnswer === 'A',
            },
            {
              text: this.testB,
              media: this.testBMedia,
              correctAnswer: this.testTrueAnswer === 'B',
            },
            {
              text: this.testC,
              media: this.testCMedia,
              correctAnswer: this.testTrueAnswer === 'C',
            },
            {
              text: this.testD,
              media: this.testDMedia,
              correctAnswer: this.testTrueAnswer === 'D',
            },
          ];
        } else {
          qt = 2;
          q = [];
        }
        axios({
          method: 'post',
          url: reqUrl,
          headers: {
            Authorization: this.$authObeject.authToken(),
          },
          data: {
            classificationId: this.qClassificationId !== '' ? this.qClassificationId : null,
            text: this.question,
            media: this.questionMedia,
            options: q,
            field: this.optionalClassification ? parseInt(this.questionSelectedField.id, 10) : -1,
            gradeId: this.optionalClassification ? this.qSelectedGradeId : null,
            lessonId: this.optionalClassification ? this.qLessonId : null,
            level: l,
            type: qt,
          },
        }).then((response) => {
          if (response.data.isSuccess) {
            this.clearQuestion();
          } else {
            this.responseFalse = true;
          }
        }, (error) => {
          this.makeToast('error', this.errorHandler(error), 3000);
        });
      }
    },
  },
  watch: {
    questionTypeSelected() {
      if (this.questionTypeSelected === 'تستی') {
        this.isTestQuestion = true;
      } else {
        this.isTestQuestion = false;
      }
    },
    questionSelectedField() {
      this.lessons = [];
      this.qLessonIdErr = true;
      if (this.questionSelectedField === '') {
        this.eField = -1;
        this.grades = [];
        this.qSelectedGradeId = '';
        this.qSelectedGradeIdErr = true;
        this.qSelectedFieldErr = true;
      } else {
        switch (this.questionSelectedField) {
          case 'حذف فیلتر': {
            this.eField = -1;
            break;
          }
          case 'متوسطه‌ی اول': {
            this.eField = 0;
            break;
          }
          case 'ریاضی': {
            this.eField = 1;
            break;
          }
          case 'تجربی': {
            this.eField = 2;
            break;
          }
          case 'انسانی': {
            this.eField = 3;
            break;
          }
          case 'فنی': {
            this.eField = 4;
            break;
          }
          case 'هنر': {
            this.eField = 1;
            break;
          }
          case 'زبان': {
            this.eField = 1;
            break;
          }
          default:
            break;
        }
        this.qSelectedFieldErr = false;
      }
    },
    questionGradeSelected() {
      if (this.questionGradeSelected === '') {
        this.lessons = [];
      } else {
        switch (this.questionSelectedField) {
          case 'زبان': {
            this.eField = 1;
            break;
          }
          default:
            break;
        }
      }
    },
    qSelectedGradeId() {
      if (this.qSelectedGradeId === '') {
        this.qSelectedGradeIdErr = true;
      } else {
        this.qSelectedGradeIdErr = false;
      }
    },
    qClassificationId() {
      if (this.qClassificationId === '') {
        this.qClassificationIdErr = true;
      } else {
        this.qClassificationIdErr = false;
      }
    },
    question() {
      this.content = this.question;
      if (this.question === '') {
        this.questionErr = true;
      } else {
        this.questionErr = false;
      }
    },
    testTrueAnswer() {
      if (this.testTrueAnswer === '') {
        this.tTrueAnsErr = true;
      } else {
        this.tTrueAnsErr = false;
      }
    },
    testA() {
      if (this.questionTypeSelected === 'تستی') {
        if (this.testA === '') {
          this.testAErr = true;
        } else {
          this.testAErr = false;
        }
      } else {
        this.testAErr = false;
      }
    },
    testB() {
      if (this.questionTypeSelected === 'تستی') {
        if (this.testB === '') {
          this.testBErr = true;
        } else {
          this.testBErr = false;
        }
      } else {
        this.testBErr = false;
      }
    },
    testC() {
      if (this.questionTypeSelected === 'تستی') {
        if (this.testC === '') {
          this.testCErr = true;
        } else {
          this.testCErr = false;
        }
      } else {
        this.testCErr = false;
      }
    },
    testD() {
      if (this.questionTypeSelected === 'تستی') {
        if (this.testD === '') {
          this.testDErr = true;
        } else {
          this.testDErr = false;
        }
      } else {
        this.testDErr = false;
      }
    },
    qLevel() {
      if (this.qLevel === '') {
        this.qLevelErr = true;
      } else {
        this.qLevelErr = false;
      }
    },
    qLessonId() {
      if (this.qLessonId === '') {
        this.qLessonIdErr = true;
      } else {
        this.qLessonIdErr = false;
      }
    },
    isSubcats() {
      if (this.isSubcats) {
        this.getClassification();
      }
    },
    // editor
    content() {
      // console.clear();
      // console.log(this.content);
    },
  },
  mounted() {
    this.$nextTick(() => {
      window.katex = katex;
      this.getClassification();
      EventBus.$on('edit', (id) => {
        this.initEdit(id);
      });
    });
  },
};
</script>

<style lang="scss" scoped>
.questionBankHolder {
  padding: 64px 8px;
  .addQuestion {
    padding-left: 16px;
    .isTrueCheckBox {
      width: 24px;
      height: 24px;
      color: gray;
      padding: 8px;
      border-radius: 50%;
      margin-left: 8px;
      border: solid 2px gray;
      border-radius: 4px;
      position: relative;
      cursor: pointer;
      * {
        pointer-events: none;
      }
      .tick {
        position: absolute;
        width: 0px;
        top: 8px;
        left: 8px;
        height: 0px;
        border: solid 4px rgb(223, 223, 223);
        border-top: none;
        border-left: none;
        transform: rotate(45deg);
      }
    }
    .isTrueCheckBox:hover {
      border-color: rgb(30, 63, 30);
    }
    .isTrueCheckBox.selected {
      border-color: rgb(30, 63, 30);
      .tick {
        border-color: green;
        width: 12px;
        top: -8px;
        left: 8px;
        height: 24px;
      }
    }
    .qDetail {
      padding: 8px;
      border-right: solid 2px rgba($color: #000000, $alpha: 0.15);
      h5 {
        font-size: 10px;
        font-weight: 300;
      }
      span.ddd {
        font-size: 14px;
        font-weight: bold;
      }
    }
    .noQ {
      height: 112px;
      padding-right: 16px;
      margin-right: 2px;
      border-right: solid 2px rgba($color: #000000, $alpha: 0.15);
      span {
        font-size: 16px;
        font-weight: 100;
        color: gray;
      }
      span.m {
        font-size: 12px;
        font-weight: 300;
        color: gray;
      }
    }
    ul {
      padding: 0;
      margin: 0;
      max-height: 350px;
      border-radius: 8px;
      border: solid 1px rgba($color: #000000, $alpha: 0.05);
      overflow: hidden auto;
      li {
        list-style-type: none;
        padding: 16px;
        border-bottom: 1px solid rgba($color: #000000, $alpha: 0.05);
        .qindex {
          width: 24px;
          min-width: 24px;
          font-size: 10px;
          font-weight: 300;
          text-align: right;
        }
        .qQuestion {
          span.q {
            font-size: 13px;
            font-weight: bold;
            text-align: right;
          }
          i {
            margin-left: 8px;
            opacity: 0.5;
            transition: all ease-in-out 0.3s;
          }
          i:hover {
            opacity: 1;
          }
          i.hard {
            color: rgb(206, 0, 0);
          }
          i.normal {
            color: rgb(27, 190, 49);
          }
          i.easy {
            color: rgb(54, 101, 161);
          }
          .qOptions {
            p {
              font-size: 12px;
              text-align: right;
              margin-top: 8px;
              font-weight: bold;
            }
          }
        }
        input[type='number'] {
          width: 80px;
          margin-left: 8px;
        }
      }
      li.selected {
        background-color: rgba($color: #000000, $alpha: 0.05);
      }
      li:hover {
        background-color: rgba($color: #000000, $alpha: 0.0) !important;
        border-bottom: 1px solid rgba($color: #000000, $alpha: 0.0);
      }
    }
  }
}
</style>
